import { render, staticRenderFns } from "./PublicationDonations.vue?vue&type=template&id=64af1370&scoped=true&"
import script from "./PublicationDonations.vue?vue&type=script&lang=js&"
export * from "./PublicationDonations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af1370",
  null
  
)

export default component.exports